import { render } from "./InvoicesTablePanel.vue?vue&type=template&id=312353c0"
import script from "./InvoicesTablePanel.vue?vue&type=script&lang=js"
export * from "./InvoicesTablePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__